import { styled, css } from 'styled-components';
import { CONTAINER_WIDTH, CONTAINER_PADDING, BREAKPOINTS } from '../../constants/layout.mjs';
"use strict";
const Wrap = styled.div`
  height: auto;
  margin: 0 auto;
  width: 100%;
  flex: 1 0 100%;
  max-width: ${({
  $size
}) => {
  switch ($size) {
    case "mobile":
      return `${CONTAINER_WIDTH.MOBILE + CONTAINER_PADDING.MOBILE * 2}px`;
    case "tablet":
      return `${CONTAINER_WIDTH.TABLET + CONTAINER_PADDING.TABLET * 2}px`;
    case "desktop":
      return `${CONTAINER_WIDTH.DESKTOP + CONTAINER_PADDING.DESKTOP * 2}px`;
    case "accounts":
      return `${CONTAINER_WIDTH.ACCOUNTS_CUSTOM + CONTAINER_PADDING.DESKTOP * 2}px`;
    case "products":
      return `${CONTAINER_WIDTH.PRODUCT_PAGE + CONTAINER_PADDING.DESKTOP * 2}px`;
    case "full":
      return `none`;
  }
}};

  box-sizing: border-box;

  ${({
  $noPaddings
}) => !$noPaddings && css`
      padding: 0 ${CONTAINER_PADDING.DESKTOP}px;

      @media ${BREAKPOINTS.TABLET_AND_DOWN} {
        padding: 0 ${CONTAINER_PADDING.MOBILE}px;
      }
    `}

  ${({
  $noVerticalMargin,
  $withExtraMargin
}) => {
  if ($noVerticalMargin) {
    return css`
        margin: 0 auto;
      `;
  }
  if ($withExtraMargin) {
    return css`
        margin: 96px auto;

        /* set back the narrower margin for mobile */
        @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
          margin: 48px auto;
        }
      `;
  }
  return css`
      margin: 48px auto;
    `;
}}
`;
const WrapPadding = styled.div`
  display: flex;
  flex-direction: column;

  ${({
  $fullHeight
}) => $fullHeight && css`
      height: 100%;
    `}
`;
export { Wrap, WrapPadding };
//# sourceMappingURL=Container.styles.mjs.map
